<div #container *ngIf="filters" class="d-flex align-items-stretch" style="flex: 1"
     [ngClass]="{'mb-0': modalOptions.fullScreen || showInReport, 'card': !showInReport, 'report-view': showInReport}">
    <ng-container *ngIf="!showInReport">
        <div class="card-header d-flex align-items-center justify-content-between">
            <h4 class="card-header-title">
                <img src="assets/images/icons/thermometer.png" width="20px" class="me-2" alt="">
                {{ chartTitleKey }}
            </h4>
            <div class="d-flex align-items-center ms-3">
                <app-data-provider-date-range class="ms-2" *ngIf="modalOptions.fullScreen"></app-data-provider-date-range>
                <button *ngIf="!modalOptions.fullScreen" type="button" class="btn ms-2" role="button" (click)="openModal()">
                    <i class="bi bi-arrows-angle-expand"></i>
                </button>
                <app-chart-download-button [element]="container"></app-chart-download-button>
                <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                        data-bs-auto-close="outside" aria-expanded="false">
                    <i class="bi bi-three-dots-vertical"></i>
                </button>
                <app-widget-options-menu title="Profile settings" [anchorBelowTrigger]="modalOptions.fullScreen">
                    <div class="dropdown-item"
                         [ngClass]="{'text-muted': openingHoursSplitDisabled}">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [id]="getInputId('splitOpeningHours')"
                                   [disabled]="openingHoursSplitDisabled"
                                   [ngModel]="showOpeningHoursSplit" (ngModelChange)="showOpeningHoursSplitChange($event)">
                            <label class="form-check-label" [for]="getInputId('splitOpeningHours')">
                                Split by opening hours
                            </label>
                            <i *ngIf="openingHoursSplitDisabled" class="bi bi-exclamation-triangle-fill ms-2"
                               data-bs-toggle="tooltip" data-bs-placement="top"
                               [title]="optionsDisabled ? 'not available due to limited measurement data' : hourlyDataAvailable === false ? 'no hourly data available' : 'no opening hours are configured for this location or building type'"></i>
                        </div>
                    </div>
                    <div class="dropdown-item" [ngClass]="{'text-muted': optionsDisabled}">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [id]="getInputId('splitWeekendWeekday')"
                                   [disabled]="optionsDisabled"
                                   [ngModel]="showWeekendWeekdaySplit" (ngModelChange)="showWeekendWeekdaySplitChange($event)">
                            <label class="form-check-label" [for]="getInputId('splitWeekendWeekday')">
                                Split by weekdays/weekend
                            </label>
                            <i *ngIf="optionsDisabled" class="bi bi-exclamation-triangle-fill ms-2"
                               data-bs-toggle="tooltip" data-bs-placement="top" title="not available due to limited measurement data"></i>
                        </div>
                    </div>
                    <div class="dropdown-item"
                         [ngClass]="{'text-muted': hourlyOptionsDisabled}">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [id]="getInputId('showHourlyEnergyProfile')"
                                   [disabled]="hourlyOptionsDisabled"
                                   [ngModel]="showHourlyEnergyProfile" (ngModelChange)="showHourlyEnergyProfileChange($event)">
                            <label class="form-check-label" [for]="getInputId('showHourlyEnergyProfile')">
                                Show hourly data
                            </label>
                            <i *ngIf="hourlyOptionsDisabled" class="bi bi-exclamation-triangle-fill ms-2"
                               data-bs-toggle="tooltip" data-bs-placement="top"
                               [title]="optionsDisabled ? 'not available due to limited measurement data' : 'no hourly data available'"></i>
                        </div>
                    </div>
                    <div *ngIf="estimatedDataVisible" class="dropdown-divider"></div>
                    <div *ngIf="estimatedDataVisible" class="dropdown-item-text small text-muted d-flex align-items-center">
                        <i class="bi bi-info-circle me-2" data-bs-toggle="tooltip" data-bs-placement="top"
                           title="20% base consumption, 80% distributed based on outdoor temperature"></i>
                        <span>Daily values are calculated</span>
                    </div>
                </app-widget-options-menu>
                <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close ms-2" data-bs-dismiss="modal"
                        aria-label="Close"></button>
            </div>
        </div>
    </ng-container>
    <div class="chart-body pt-0 mh-100 d-flex align-items-stretch overflow-hidden"
         [ngClass]="{'card-body': !showInReport}">
        <div *ngIf="stateMessage" class="d-flex align-items-center justify-content-center text-center text-muted p-3 energy-profile-empty-state"
             style="min-height: 350px;">
            {{ stateMessage }}
        </div>
        <ng-container *ngIf="!stateMessage">
            <app-scatter-chart class="chart d-flex flex-grow-1 h-100 w-100"
                               [dataProvider]="chartDataProvider"
                               [height]="modalOptions.fullScreen || showInReport ? 500 : 300"
                               [fullScreen]="modalOptions.fullScreen"
                               [axisMode]="'linear'"
                               [xAxisTitle]="xAxisTitle"
                               [yAxisTitle]="yAxisTitle"
                               [showLegend]="showOpeningHoursSplit || showWeekendWeekdaySplit"
                               [useEnergyProfileOptions]="true"
                               [suggestedMinY]="0"
                               [scales]="scales"
                               [pluginOptions]="pluginOptions">
            </app-scatter-chart>
        </ng-container>
    </div>
</div>
